import { Injector } from "@angular/core";
import { EntityEnum } from "../../../EntityEnum";
import { MedicinalProductsSimpleQueryNode } from "../../MedicinalProductsSimpleQueryNode";
import { ResultList } from "../../../ListEntity/ResultList";
import { ListColumn } from "../../../../Data/ListColumn";
import { OwnedEVMPDEntitiesListView } from "../../../../Data/MedicinalProductData/OwnedEVMPDEntitiesListView";
import { SearchField } from "../../../../SearchField";

export class OwnedEVMPDEntitiesQueryNode extends MedicinalProductsSimpleQueryNode {
    constructor(injector: Injector) {
       super(injector, [], 'Owned XEVMPD Entities', EntityEnum.ownedEVMPDEntities);
       this.children!.push(new ResultList(injector));
    }

    override getFieldsToShow(): ListColumn[] {
        return new OwnedEVMPDEntitiesListView({}).itemFinderArrayColumns;
    }

    override getFields(): string {
        const searchField = new SearchField();
        searchField.addField("entity", "Entity");
        searchField.addField("art57", "Article 57 Format");
        searchField.addField("type", "Type");
        searchField.addField("status", "Status");
        searchField.addField("count", "Number");
        return searchField.getJSONString();
    }
}